import React, { ReactNode } from 'react';
import { RiPencilLine } from 'react-icons/ri';
import Styles from './EditMenuButton.module.scss';
import { Button } from '~/components/common/parts/button/Button';

type Props = {
  children: ReactNode;
  onClick: () => void | Promise<void>;
};

export const EditMenuButton: React.FC<Props> = ({
  children,
  onClick
}: Props) => (
  <Button onClick={onClick} size="sm" variant="normal">
    <RiPencilLine className={Styles.Icon} />
    {children}
  </Button>
);
